var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"type-wrap"},_vm._l((_vm.types),function(item,index){return _c('span',{key:index,class:{actived:_vm.type === item.key},on:{"click":function($event){return _vm.switchType(item.key)}}},[_vm._v(_vm._s(item.value))])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }